module.exports = __webpack_public_path__ + "img/icon_addpatient_schedule.7983c969.svg";